import LoginMain from "./LoginMain";
import OTPLoginMain from './OTPLoginMain';

export {OTPLoginMain};
export {MFALoginMain} from './MFALoginMain';
export default LoginMain;